import React from 'react'
import { useEffect, useRef, useState, createRef } from 'react'
import { SActionBtn, SLowcodeList, STableActions, SBack, SDrawer, SMessage } from 'shj-components'
import config from './config'
import { Tooltip, Modal, message } from 'antd'
import { rulesPlanErrListByPage, rulesPlanErrListByRetry, getEnum, rulesPlanErrCloseOrderById } from '@/services/fmsServices'

export default function PaymentServiceManage() {
  const [editData, setEditData] = useState<any>(null)
  const [open, setOpen] = useState(false)
  const [statusLoading, setStatusLoading] = useState<string>('');  // 存储正在切换状态的行 id
  const listRef = useRef<any>()
  const [messageApi, contextHolder] = message.useMessage();
  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, query } = values
        query.enableCompanyPermission = true
        rulesPlanErrListByPage(current, pageSize, query).then(res => {
          resolve(res)
        })
      } catch (e) {
        reject({ success: false })
      }
    })
  }
  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };
  const onEdit = (record = {}) => {
    // modalAddOrEditFn({
    //   fn: () => {},
    //   ...record,
    // })
    setEditData(record)
    setOpen(true)
  }
  const onClose = (record: any) => {
    let dialog = SMessage.confirm({
      title: '确认关闭',
      content: '确认关闭此数据?',
      onOk: () => {
        rulesPlanErrCloseOrderById({id: record.id}).then((res: any) => {
          message.success(res.message || '关闭成功');
          listRef.current && listRef.current.reload();
        });
        dialog?.destroy();
      },
      onCancel: () => {
        dialog?.destroy();
      },
    });

    
  }
  const onRetry = record => {
    setStatusLoading(record.id)
    rulesPlanErrListByRetry({ id: record.id })
      .then(res => {
        if(res){
          // Modal.success({
          //   title: '重试成功',
          //   content: res.message,
          // })
          messageApi.open({
            type: 'success',
            content: res.message || '重试成功',
          });
        }else{
          // Modal.error({
          //   title: '重试失败',
          //   content: res.message,
          // })
          messageApi.open({
            type: 'error',
            content: res.message || '重试失败',
          });
        }
        reloadFn()
      }).catch(err => {
        // Modal.error({
        //   title: '重试失败',
        //   content: err.messages,
        // });
      }).finally(()=>{
        setStatusLoading('')
      })
  }
  const getStatusOptions = () => {
    return new Promise(async resolve => {
    const errStateList: any = await getEnum('com.shj.saas.plus.fms.enums.rules.ErrRulesStateEnum')
      resolve({errStateList})
    })
  }

  // 右侧表格配置
  const extension = {
    request: { fetchList, getStatusOptions },
    events: {},
    customRender: {
      renderOperate(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn auth="AbnormalErrorEdit" onClick={() => onEdit(record)}>价格明细</SActionBtn>
            {
              record.state === 'handler_pending' ?  <SActionBtn auth="AbnormalErrorRetry" loading={statusLoading===record.id} onClick={() => onRetry(record)}>重试</SActionBtn> : null
            }
            {
              record.state === 'handler_pending' ?  <SActionBtn auth="AbnormalErrorClose" onClick={() => onClose(record)}>关闭</SActionBtn> : null
            }
          </STableActions>
        )
      },
      operateTooltip(text: string, record: object) {
        return (
          <Tooltip 
            title={<div dangerouslySetInnerHTML={{ __html: text }} />} 
            overlayStyle={{ 
              minWidth: '150px', 
              maxWidth: '840px',
            }}
          >
            <div
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                width: '440px',
                WebkitLineClamp: '1',
                WebkitBoxOrient: 'vertical',
              }}
            >
              {text}
            </div>
          </Tooltip>
        )
      },
    },
  }
  return (
    <SBack title={`收款计划异常数据`} level={2}>
        {contextHolder}
        <SLowcodeList config={config} ref={listRef} {...extension} searchMode="group" />
        <SDrawer
          title="价格明细"
          open={open}
          width={'30%'}
          onClose={() => setOpen(false)}
          footer={null}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 5, fontWeight: 600, fontSize: 16}}>
            <span style={{color: 'rgba(45, 45, 46, 1)' }}>合同金额</span>
            <span style={{color: 'rgba(242, 90, 10, 1)'}}>￥{editData?.paymentRequest?.contractAmount}</span>
          </div>
          <div style={{ marginTop: 20 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 600, fontSize: 16 }}>
              <span style={{color: 'rgba(45, 45, 46, 1)' }}>其他收款项目合计</span>
              <span style={{color: 'rgba(242, 90, 10, 1)'}}>￥{editData?.paymentRequest?.otherTypesList.reduce((total, item) => total + item.amount, 0)}</span>
            </div>
            <ul style={{paddingLeft: 10}}>
              {
                editData?.paymentRequest?.otherTypesList.map((item) => {
                  return (
                    <li style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 400, fontSize: 14, marginTop: 10 }}>
                      <span>{item.otherPriceItemTypeName}</span>
                      <span>￥{item.amount}</span>
                    </li>
                  )
                })
              }
            </ul>
          </div>
        </SDrawer>
    </SBack>
  )
}
